import Keycloak from "keycloak-js"

const keycloak = new Keycloak({
    realm: process.env.GATSBY_KC_REALM,
    url: process.env.GATSBY_KC_URL,
    clientId: process.env.GATSBY_KC_CLIENTID,
})

export default keycloak
